<div class="image-gallery-wrap">
  <div class="container">
    @if (finalImages?.length > 0) {
      @if (showAllImages) {
        <ul class="image-gallery show-all">
          @for (imageItem of finalImages; track imageItem; let index = $index) {
            @defer (on viewport) {
              <li (click)="onImageClick(imageItem)">
                <div class="img-sec">
                  <img
                    [ngSrc]="imageItem?.path + '?format=webp&quality=90'"
                    [alt]="imageItem?.alt"
                    [width]="compData?.width"
                    [height]="compData?.height"
                    #image
                    (error)="image.src = placeHolderImage + '?format=webp&quality=90&width='+ compData?.width + '&height=' + compData?.height"
                  >
                </div>
              </li>
            } @placeholder {
              <div><!-- TODO placeholder --></div>
            }
          }
        </ul>
      }


      @if (!showAllImages) {
        <div class="banner-img">
          <div class="banner-img-gallery">
            <div class="gallery">
              @for (imageItem of finalImages | slice: start: end; track imageItem; let index = $index) {
                <div class="gallery-item" (click)="onLimitedImageClick()">
                  @defer (on viewport) {
                    <img
                      [ngSrc]="imageItem?.path + '?format=webp&quality=90'"
                      [alt]="imageItem?.alt"
                      [width]="diffImageSizes[index]?.width"
                      [height]="diffImageSizes[index]?.height"
                      #image
                      (error)="image.src = placeHolderImage + '?format=webp&quality=100&width=700&height=449'"
                      class="gallery-img"
                      [priority]="index === 0"

                    >
                    <div class="overlay"></div>
                    @if (this.compData?.container?.imageSliceLength > 0) {
                      <div
                        class="view-all">
                        <span class="view-all-btn">See All Images</span>
                      </div>
                    }
                  } @placeholder {
                    <div><!-- TODO placeholder --></div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
    } @else {
      <div class="image-not-found">
        <div class="placeholder-img">
          <img [ngSrc]="placeHolderImage" alt="placeholder" width="200" height="150">
        </div>
      </div>
    }


  </div>
</div>
